import loadable from "@loadable/component";

export const CmsForms = loadable(() => import("./CmsForm/index.form"));
export const FaqForm = loadable(() => import("./FaqForm/index.form"));
